<template>
  <v-container fluid dense style="scroll">
    <h1 class="text-center">Scambio dati</h1>
    <h2 v-if="modelliTotali.length === 0" class="red--text">
      <br /><br /><br />Attualmente non sono definite procedure di scambio dati
    </h2>
    <template v-if="modelliTotali.length > 0">
      <v-row
        class="mt-0"
        justify="space-around"
        v-for="(m, idx) in modelliTotali"
        :key="idx"
      >
        <v-col cols="11">
          <v-card :loading="loadingR(idx)">
            <v-card-title>
              <span class="text-h5">{{ m.titolo }}</span>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="scambioDati(m.codice, idx, true, m.tipo)"
                :loading="loadingR(idx)"
                >Avvia Manuale</v-btn
              >
            </v-card-title>
            <v-card-subtitle>
              {{ m.descrizione }}
              <span class="mx-4 text-subtitle-3 red--text text-right">{{
                eseguito[idx] || ""
              }}</span>
            </v-card-subtitle>
            <div class="mx-4 text-subtitle-2">
              Tipo
              {{
                `${m.tipo === "export" ? "esportazione" : "importazione"}:
              ${m.file.tipo}`
              }}
            </div>
            <div class="mx-4 text-subtitle-2">
              Destinazione: {{ m.file.destinazione || "locale" }}
            </div>
            <div class="mx-4 text-subtitle-2" v-if="m.tipo === 'export'">
              Dalla data: {{ computedStartFormatted(idx) || "date" }}
            </div>
            <div class="mx-4 text-subtitle-2 pb-2" v-if="m.tipo === 'export'">
              Alla data: {{ computedEndFormatted(idx) || "date" }}
            </div>

            <!-- TODO: Inserire switch "Esegui manuale" + impostazione date -->
          </v-card>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
/* eslint-disable */
import _ from "lodash";
import moment from "moment";
import { verificaLicenza } from "@/mixins/verificaLicenza.js";
import configurazioni from "@/services/configurazioniService.js";
import exportService from "@/services/exportService.js";
import importService from "@/services/importService.js";

export default {
  mixins: [verificaLicenza],
  props: {
    chiave: { type: String, default: "not-set" },
  },
  data: (vm) => ({
    modelli: [],
    modelliImport: [],
    startFormatted: [],
    endFormatted: [],
    filtro: [],
    menuStart: [],
    menuEnd: [],
    loading: {},
    avvia: false,
    eseguito: {},
  }),
  computed: {
    modelliTotali() {
      return this.modelli.concat(this.modelliImport);
    },
  },
  watch: {
    "filtro.start"(val) {
      this.startFormatted = this.formatDate(this.filtro.start);
    },
    "filtro.end"(val) {
      this.endFormatted = this.formatDate(this.filtro.end);
    },
  },
  async mounted() {
    await this.gestioneToken();
    const payload = await configurazioni.takeMemoriaCondivisa(this.chiave);
    if (payload) {
      this.avvia = payload.avviaAutomatiche;
    }
    await this.verificaModuliLocali();
    const modelli = await configurazioni.getConfigurazione(
      "export_dati",
      "modelli"
    );
    this.modelli = modelli.generici;

    let idx = 0;
    const daAvviare = [];
    for (let m of this.modelli) {
      m.tipo = "export";
      const start = moment()
        .add(_.get(m, "periodo.giorniStart", 0), "days")
        .format("YYYY-MM-DD");
      const end = moment()
        .add(_.get(m, "periodo.giorniEnd", 0), "days")
        .format("YYYY-MM-DD");
      const filtro = {
        start: start,
        end: end,
      };
      this.filtro.push(filtro);
      this.menuStart.push(false);
      this.menuEnd.push(false);
      this.startFormatted.push(start);
      this.endFormatted.push(end);

      if (_.get(m, "avvio.automatico", false) && this.avvia) {
        daAvviare.push({ codice: m.codice, idx: idx, tipo: "export" });
      }
      idx++;
    }
    const modelliImport = await configurazioni.getConfigurazione(
      "import_dati",
      "modelli"
    );
    this.modelliImport = modelliImport.automatici || [];

    for (let m of this.modelliImport) {
      m.tipo = "import";
      if (_.get(m, "avvio.automatico", false) && this.avvia) {
        daAvviare.push({ codice: m.codice, idx: idx, tipo: "import" });
      }
      idx++;
    }

    if (daAvviare.length > 0) {
      setTimeout(async () => {
        for (let av of daAvviare) {
          console.log("avvio", av.codice, av.idx, av.tipo);
          if (av.tipo === "export") {
            await this.onEsporta(av.codice, av.idx);
          } else {
            await this.onImporta(av.codice, av.idx);
          }
        }
      }, 100);
    }
  },
  methods: {
    loadingR(idx) {
      return this.loading[idx];
    },
    computedStartFormatted(idx) {
      return this.formatDate(this.filtro[idx].start);
    },
    computedEndFormatted(idx) {
      return this.formatDate(this.filtro[idx].end);
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    async scambioDati(codiceModello, idx, verbose, tipo) {
      if (tipo === "import") {
        await this.onImporta(codiceModello, idx, verbose);
      } else {
        await this.onEsporta(codiceModello, idx, verbose);
      }
    },
    async onEsporta(codiceModello, idx, verbose) {
      this.loading[idx] = true;
      this.eseguito[idx] = "";
      this.$forceUpdate();

      const modello = this.modelli.find((x) => x.codice === codiceModello);
      const filtro = this.filtro[idx];
      try {
        const esportazione = await exportService.esportaDaModello(
          modello,
          filtro
        );
        const dati = esportazione.dati;
        if (dati.length > 0 || _.get(modello, "file.creaFileVuoto")) {
          const result = await exportService.generaFile(
            modello,
            dati,
            document
          );
          if (verbose && result) {
            alert(result.status);
          }
        }
        if (modello.marcaTrasferiti) {
          await exportService.marcaTrasferiti(
            esportazione.tipo,
            codiceModello,
            esportazione.ids
          );
        }
        this.eseguito[idx] = `TRASFERIMENTO ESEGUITO (${
          dati.length > 0 ? "dati presenti" : "no dati"
        }) !`;
      } catch (error) {
        console.log(error);
      }
      this.loading[idx] = false;
      this.$forceUpdate();
    },
    async onImporta(codiceModello, idx, verbose) {
      this.loading[idx] = true;
      this.eseguito[idx] = "";
      this.$forceUpdate();

      const modello = this.modelliImport.find(
        (x) => x.codice === codiceModello
      );
      try {
        const importazione = await importService.leggeFile(
          modello.file.nomeFile,
          modello
        );
        const dati = importazione.dati;
        const importazioneProdotti = await importService.leggeFile(
          modello.file.nomeFileProdotti,
          modello
        );
        const arrProdotti = _.uniq(importazioneProdotti.dati);
        const datiProdotti = arrProdotti.map((x) => x.split(";"));

        if (dati.length > 0) {
          const result = await importService.generaMovimenti(
            modello,
            dati,
            datiProdotti
          );
          if (verbose && result) {
            alert(result.status);
          }
        }
        if (modello.eliminaFile) {
          await importService.eliminaFile(importazione.file, modello);
          await importService.eliminaFile(importazioneProdotti.file, modello);
        }
        this.eseguito[idx] = `IMPORT ESEGUITO (${
          dati.length > 0 ? "dati presenti" : "no dati"
        }) !`;
      } catch (error) {
        console.log(error);
      }
      this.loading[idx] = false;
      this.$forceUpdate();
    },
  },
};
</script>
